import { CircularProgress, Stack } from '@mui/material'

const Progress = ({ padding = '100px 0', size = 70 }) => (
  <Stack justifyContent={'center'} width={'100%'} alignItems={'center'} padding={padding}>
    <CircularProgress color="primary" size={size} />
  </Stack>
)

export default Progress
